import React from 'react';

const FAQSearch = ({ query, onChange, resultCount }) => {
  return (
    <div style={{ marginBottom: '40px' }}>
      <div style={{ position: 'relative', maxWidth: '600px' }}>
        <div style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(224,228,232,0.4)" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </div>
        <input
          type="text"
          value={query}
          onChange={e => onChange(e?.target?.value)}
          placeholder="Søk i spørsmål og svar..."
          style={{
            width: '100%',
            background: 'rgba(255,255,255,0.03)',
            border: 'none',
            borderBottom: '2px solid rgba(224,228,232,0.15)',
            borderRadius: '2px 2px 0 0',
            padding: '14px 16px 14px 48px',
            fontFamily: 'var(--font-body)',
            fontSize: '15px',
            fontWeight: 300,
            color: 'var(--color-foreground)',
            outline: 'none',
            transition: 'border-color 200ms ease',
            boxSizing: 'border-box',
          }}
          onFocus={e => e.target.style.borderBottomColor = '#FF5722'}
          onBlur={e => e.target.style.borderBottomColor = 'rgba(224,228,232,0.15)'}
        />
        {query && (
          <button
            onClick={() => onChange('')}
            style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', color: 'var(--color-muted-foreground)' }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        )}
      </div>
      {query && (
        <p style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 300, color: 'var(--color-muted-foreground)', marginTop: '8px', letterSpacing: '0.04em' }}>
          {resultCount} resultat{resultCount !== 1 ? 'er' : ''} funnet
        </p>
      )}
    </div>
  );
};

export default FAQSearch;
